export default __webpack_public_path__ + "assets/icon-category.b647055e.webp";